export const de = {
  mention: {}
};
